'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { KOALA } from 'HubStyleTokens/colors';
export default function ViewToolbarDivider() {
  return /*#__PURE__*/_jsx("div", {
    className: "m-right-4",
    style: {
      width: 1,
      height: 30,
      backgroundColor: KOALA
    }
  });
}